"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var AttachmentsActionTypes = {
  ATTACHMENTS_FETCH_FAILED: 'ATTACHMENTS_FETCH_FAILED',
  ATTACHMENTS_FETCH_QUEUED: 'ATTACHMENTS_FETCH_QUEUED',
  ATTACHMENTS_FETCH_STARTED: 'ATTACHMENTS_FETCH_STARTED',
  ATTACHMENTS_FETCH_SUCCEEDED: 'ATTACHMENTS_FETCH_SUCCEEDED',
  ATTACHMENTS_UPDATED: 'ATTACHMENTS_UPDATED'
};
var _default = AttachmentsActionTypes;
exports.default = _default;
module.exports = exports.default;